/* eslint-disable no-alert */
// @TODO: replace confirm with plugin when its written

$(() => {
  const $snackBar = $('[data-js-snack-bar]');

  /**
   * jQuery plugin for a Race Roster event store cart.
   * @param options
   * @returns {*}
   */
  $.fn.storeCart = function store(options) {
    const defaults = {
      templates: {
        spinner: '<span class="fa fa-pulse fa-spinner" aria-hidden="true"></span>',
      },
      selectors: {
        dirty: '.js-dirty',
        defaultParticipantAssignment: '.js-store-cart-default-participant-assignment',
        product: '.js-store-cart-product',
        removeProduct: '.js-store-cart-remove-product',
        productOptionItem: '.js-store-cart-product-option-item',
        removeProductOptionItem: '.js-store-cart-remove-product-option-item',
        assignParticipant: '.js-store-cart-assign-participant',
      },
    };

    /**
     * Add readonly to all inputs (so focus is maintained when re-enabled and the .disabled class
     * to all buttons
     * @param $product
     * @param enable
     */
    const toggleControls = ($product, enable) => {
      $product.find(':input').attr('readonly', !enable);
      $product.find(':button').toggleClass('disabled', !enable);
    };

    /**
     * Sometimes there is no option name or sometimes the option name is the same as the product
     * name which looks silly, so, like, this does something about it
     * @param productName
     * @param productOptionName
     * @param settings
     * @returns {string}
     */
    const getConfirmationText = (productName, productOptionName, settings) => {
      if (!productOptionName || productName === productOptionName) {
        return settings.i18n.confirmRemoveProduct.replace('%product_name%', productName);
      }

      return settings.i18n.confirmRemoveProductOptionItem
        .replace('%product_name%', productName)
        .replace('%option_name%', productOptionName);
    };

    /**
     * Remove the product
     * @param event
     * @param settings
     */
    const removeProduct = (event, settings) => {
      const $removeButton = $(event.currentTarget);
      const ajaxUrl = $removeButton.data('ajax-url');
      const $product = $removeButton.closest(settings.selectors.product);
      const productName = $product.data('product-name');
      const confirmed = window.confirm(getConfirmationText(productName, false, settings));

      if (confirmed) {
        const $spinner = $(settings.templates.spinner);

        $removeButton.prepend($spinner);
        toggleControls($product, false);

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
        }).done(() => {
          window.location.reload();
        }).fail((response) => {
          $snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: response.responseText,
          });
          $spinner.remove();
          toggleControls($product, true);
        });
      }
    };

    /**
     * Assign a participant to a product option item
     * @param $select
     * @param settings
     */
    const assignParticipant = ($select, settings) => {
      const ajaxUrl = $select.data('ajax-url');
      const participantUuid = $select.val();
      const $productOptionItem = $select.closest(settings.selectors.productOptionItem);
      const $removeButton = $select.siblings(settings.selectors.removeProductOptionItem);
      const $removeButtonContents = $removeButton.contents().clone();
      const $spinner = $(settings.templates.spinner);

      $removeButton.html($spinner);
      toggleControls($productOptionItem, false);

      $.ajax({
        url: ajaxUrl,
        type: 'POST',
        data: {
          uuid: participantUuid,
        },
      }).always(() => {
        $removeButton.html($removeButtonContents);
        toggleControls($productOptionItem, true);
      }).done(() => {
        window.location.reload();
      }).fail((response) => {
        $snackBar.snackBar('add', {
          type: 'danger',
          icon: 'exclamation-circle',
          content: response.responseText,
        });
      });
    };

    /**
     * On change listener for assigning participants. Adds the dirty class and sends the assign
     * participant request
     * @param event
     * @param settings
     */
    const assignParticipantChange = (event, settings) => {
      const $select = $(event.currentTarget);

      $select.addClass(settings.selectors.dirty.substring(1));
      assignParticipant($select, settings);
    };

    /**
     * Updates the default participant. Updates the text in each select to show (default
     * participant) and updates the participant value if that select hasn't been marked as dirty
     * @param event
     * @param settings
     */
    const assignDefaultParticipant = (event, settings) => {
      const participantUuid = $(event.currentTarget).val();

      settings.elements.$store.find(settings.selectors.assignParticipant).each((index, select) => {
        const $select = $(select);
        const $currentDefaultParticipantOption = $select.find('[data-default-participant]');
        const $newDefaultParticipantOption = $select.find(`[value="${participantUuid}"]`);

        $currentDefaultParticipantOption.removeAttr('data-default-participant')
          .text($currentDefaultParticipantOption.text().replace(settings.i18n.defaultParticipant, '').trim());

        $newDefaultParticipantOption.attr('data-default-participant', '')
          .text(`${$newDefaultParticipantOption.text()} ${settings.i18n.defaultParticipant}`);

        if (!$select.hasClass(settings.selectors.dirty.substring(1))) {
          $select.val(participantUuid);
          assignParticipant($select, settings);
        }
      });
    };

    /**
     * Remove the product option item
     * @param event
     * @param settings
     */
    const removeProductOptionItem = (event, settings) => {
      const $removeButton = $(event.currentTarget);
      const ajaxUrl = $removeButton.data('ajax-url');
      const $productOptionItem = $removeButton.closest(settings.selectors.productOptionItem);
      const $product = $productOptionItem.closest(settings.selectors.product);
      const productOptionName = $productOptionItem.data('product-option-name');
      const productName = $product.data('product-name');
      const confirmed = window
        .confirm(getConfirmationText(productName, productOptionName, settings));

      if (confirmed) {
        const $removeButtonContents = $removeButton.contents().clone();
        const $spinner = $(settings.templates.spinner);

        $removeButton.html($spinner);
        toggleControls($productOptionItem, false);

        $.ajax({
          url: ajaxUrl,
          type: 'POST',
        }).done(() => {
          window.location.reload();
        }).fail((response) => {
          $snackBar.snackBar('add', {
            type: 'danger',
            icon: 'exclamation-circle',
            content: response.responseText,
          });
          $removeButton.html($removeButtonContents);
          toggleControls($productOptionItem, true);
        });
      }
    };

    /**
     * Fire up
     */
    const initialize = function initialize() {
      const settings = $.extend(true, {}, defaults, options);
      const $store = $(this);

      settings.elements = {
        $store,
      };

      $store.on(
        'change',
        settings.selectors.defaultParticipantAssignment,
        (event) => assignDefaultParticipant(event, settings),
      );

      $store.on('click', settings.selectors.removeProduct, (event) => removeProduct(event, settings));

      $store.on(
        'change',
        settings.selectors.assignParticipant,
        (event) => assignParticipantChange(event, settings),
      );

      $store.on(
        'click',
        settings.selectors.removeProductOptionItem,
        (event) => removeProductOptionItem(event, settings),
      );
    };

    return this.each(initialize);
  };
});
